/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import extractText from 'flarum/common/utils/extractText';
import type Discussion from 'flarum/common/models/Discussion';
import ReviewPage from '../components/ReviewPage';

/** Core types `PageState.data` as `{}`; the router stores the matched `routeName` on it. */
type RouteData = { routeName?: string };

/**
 * DiscussionControls, with the actions that have to refresh the article page overridden.
 *
 * CORE_CODE_OVERRIDE
 */
export default {
	...DiscussionControls,

	hideAction(this: Discussion): void {
		DiscussionControls.hideAction.call(this).then(() => {
			try {
				if ((app.current.data as RouteData).routeName === 'of_article') {
					app.store.find('of_articles', String(Number.parseInt(m.route.param('id')))).then(m.redraw);
				}
			} catch (e) {}
		});
	},

	restoreAction(this: Discussion): void {
		DiscussionControls.restoreAction.call(this).then(() => {
			try {
				if ((app.current.data as RouteData).routeName === 'of_article') {
					app.store.find('of_articles', String(Number.parseInt(m.route.param('id')))).then(m.redraw);
				}
			} catch (e) {}
		});
	},

	deleteAction(this: Discussion): Promise<void> | void {
		if (confirm(extractText(app.translator.trans('core.forum.discussion_controls.delete_confirmation')))) {
			// Leave the page we are about to delete.
			if (app.current.matches(ReviewPage, { discussion: this })) {
				app.history.back();
			}

			return this.delete().then(() => {
				if ((app.current.data as RouteData).routeName === 'of_article') {
					try {
						app.articleReviews.removeDiscussion(this);
						app.store.find('of_articles', String(Number.parseInt(m.route.param('id')))).then(m.redraw);
					} catch (e) {}
				} else {
					app.reviews.removeDiscussion(this);
				}
			});
		}
	},
};
